import Headroom from 'headroom.js';

const onUnpin = function() {
    const headerCheckboxes = document.querySelectorAll('.header-menu__sub-menu-checkbox');
    headerCheckboxes.forEach(element => {
        element.checked = false;
    })
}

const headerElement = document.querySelector('.header-menu__headroom');
let headroom = null;
if (headerElement) {
    // construct an instance of Headroom, passing the element
    headroom = new Headroom(headerElement, {
        "offset": 205,
        "tolerance": {
            up : 30,
            down : 0
        },
        onUnpin: onUnpin,
    });
    // initialise
    headroom.init();
    if (document.documentElement.scrollTop > 400) {
        headroom.unpin();
    }
}

export { headroom };


// WEBPACK FOOTER //
// ./resources/assets/js/header-menu.js